import * as React from "react";
import type { SVGProps } from "react";
const SvgTelegramBot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={140}
    height={140}
    fill="none"
    {...props}
  >
    <path
      fill="url(#telegram-bot_svg__a)"
      d="M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M25 67.156V39.264a1.844 1.844 0 0 1 3.688 0v12.775c5.201-9.99 15.406-16.995 27.39-17.617l4.422-.23 4.422.23c11.984.622 22.189 7.627 27.39 17.617V39.263a1.844 1.844 0 1 1 3.688 0v35.27c0 6.57-10.604 11.526-35.5 11.526S25 81.103 25 74.533zM42.059 54.94a9.22 9.22 0 1 0 0 18.441h36.883a9.22 9.22 0 0 0 0-18.441z"
      clipRule="evenodd"
    />
    <circle cx={42.059} cy={64.159} r={4.61} fill="#fff" />
    <circle cx={78.941} cy={64.159} r={4.61} fill="#fff" />
    <g filter="url(#telegram-bot_svg__b)">
      <path
        fill="url(#telegram-bot_svg__c)"
        d="M100 128c15.464 0 28-12.536 28-28s-12.536-28-28-28-28 12.536-28 28 12.536 28 28 28"
      />
      <path
        stroke="#fff"
        strokeWidth={4}
        d="M100 130c16.569 0 30-13.431 30-30 0-16.568-13.431-30-30-30-16.568 0-30 13.432-30 30 0 16.569 13.432 30 30 30Z"
      />
    </g>
    <path
      fill="#C8DAEA"
      d="M94.867 112.833c-.907 0-.753-.342-1.066-1.206l-2.667-8.779 20.533-12.181"
    />
    <path
      fill="#A9C9DD"
      d="M94.866 112.833c.7 0 1.01-.32 1.4-.7l3.733-3.63-4.656-2.808"
    />
    <path
      fill="url(#telegram-bot_svg__d)"
      d="m95.342 105.696 11.284 8.336c1.288.711 2.217.343 2.538-1.195l4.593-21.645c.47-1.885-.718-2.74-1.95-2.181l-26.971 10.4c-1.841.738-1.83 1.765-.336 2.223l6.921 2.16 16.024-10.109c.757-.459 1.451-.212.881.294"
    />
    <defs>
      <linearGradient
        id="telegram-bot_svg__a"
        x1={80.04}
        x2={50.04}
        y1={20.04}
        y2={90}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37AEE2" />
        <stop offset={1} stopColor="#1E96C8" />
      </linearGradient>
      <linearGradient
        id="telegram-bot_svg__c"
        x1={109.352}
        x2={95.352}
        y1={81.352}
        y2={114}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37AEE2" />
        <stop offset={1} stopColor="#1E96C8" />
      </linearGradient>
      <linearGradient
        id="telegram-bot_svg__d"
        x1={103.51}
        x2={107.88}
        y1={100.002}
        y2={109.958}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EFF7FC" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <filter
        id="telegram-bot_svg__b"
        width={88}
        height={88}
        x={56}
        y={56}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={6} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_302_1712"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_302_1712"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgTelegramBot;
